export default {
    // 將 getters, actions, mutations 設定為區域變數
    namespaced: true,
    state: {
      // 儲存狀態資料
      lang: null,
    },
    getters: {
      // computed
    },
    actions: {
      // methods (ajax、setTimeout 請寫在這)
      // 負責觸發 mutation
      /// context: 固定參數; payLoad(載荷): 外部傳入的參數(使用者自訂)
      updateLang(context, payLoad) {
        context.commit("CHANGE_LANG", payLoad);
      },
    },
    mutations: {
      // 改變 state 資料內容的方法
      // 撰寫習慣: function 名稱全大寫
      CHANGE_LANG(state, payLoad) {
        localStorage.setItem("i18n", payLoad);
        state.lang = payLoad;
      },
    },
  };
  